const mojibakePattern = /[ÃÂâð]/u;

const windows1252Bytes = new Map([
  [0x20ac, 0x80],
  [0x201a, 0x82],
  [0x0192, 0x83],
  [0x201e, 0x84],
  [0x2026, 0x85],
  [0x2020, 0x86],
  [0x2021, 0x87],
  [0x02c6, 0x88],
  [0x2030, 0x89],
  [0x0160, 0x8a],
  [0x2039, 0x8b],
  [0x0152, 0x8c],
  [0x017d, 0x8e],
  [0x2018, 0x91],
  [0x2019, 0x92],
  [0x201c, 0x93],
  [0x201d, 0x94],
  [0x2022, 0x95],
  [0x2013, 0x96],
  [0x2014, 0x97],
  [0x02dc, 0x98],
  [0x2122, 0x99],
  [0x0161, 0x9a],
  [0x203a, 0x9b],
  [0x0153, 0x9c],
  [0x017e, 0x9e],
  [0x0178, 0x9f]
]);

function suspiciousScore(value) {
  return (String(value || "").match(mojibakePattern) || []).length;
}

function encodeWindows1252(value) {
  const bytes = [];

  for (const character of String(value || "")) {
    const codePoint = character.codePointAt(0);
    if (codePoint <= 0xff) {
      bytes.push(codePoint);
      continue;
    }

    const byte = windows1252Bytes.get(codePoint);
    if (byte === undefined) return null;
    bytes.push(byte);
  }

  return new Uint8Array(bytes);
}

function manualMojibakeRepair(value) {
  return String(value || "")
    .replaceAll("â€œ", "“")
    .replaceAll("â€", "”")
    .replaceAll("â€˜", "‘")
    .replaceAll("â€™", "’")
    .replaceAll("â€“", "–")
    .replaceAll("â€”", "—")
    .replaceAll("â€¦", "…")
    .replaceAll("â€¢", "•")
    .replaceAll("Â©", "©")
    .replaceAll("Â·", "·")
    .replaceAll("Â", "");
}

export function repairMojibake(value) {
  const text = String(value || "");
  if (!mojibakePattern.test(text)) return text;

  const bytes = encodeWindows1252(text);
  if (bytes && typeof TextDecoder !== "undefined") {
    const repaired = new TextDecoder("utf-8", { fatal: false }).decode(bytes);
    if (!repaired.includes("\uFFFD") && suspiciousScore(repaired) < suspiciousScore(text)) {
      return repaired;
    }
  }

  return manualMojibakeRepair(text);
}

export function normalizeDisplayText(value, { collapseWhitespace = true, stripMarkdown = false } = {}) {
  let text = repairMojibake(value)
    .replace(/\u0000/g, "")
    .trim();

  if (stripMarkdown) {
    text = text.replace(/\*([^*]+)\*/g, "$1");
  }

  if (collapseWhitespace) {
    text = text.replace(/\s+/g, " ");
  }

  return text.trim();
}
